import RequestBodyForm_vue_vue_type_script_setup_true_lang_default from "./RequestBodyForm.vue.script.js";
//#region src/v2/blocks/request-block/components/RequestBodyForm.vue
var RequestBodyForm_default = RequestBodyForm_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { RequestBodyForm_default as default };

//# sourceMappingURL=RequestBodyForm.vue.js.map